import { cx } from "@/utils";
import { Field, Label } from "../../fieldset";
import { Input, InputGroup } from "../../input";

const TextField = ({ label, error, className, description, ...props }) => (
  <Field className="w-full">
    <Label>{label}</Label>
    <InputGroup>
      <Input
        className={cx("bg-transparent", className)}
        invalid={Boolean(error)}
        {...props}
        type="text"
      />
    </InputGroup>
    {error && (
      <div className="mt-3">
        <p className="text-xs font-semibold text-red-500">{error}</p>
      </div>
    )}
    {description && (
      <div className="mt-3">
        <p className="text-cp-grey-600 text-xs">{description}</p>
      </div>
    )}
  </Field>
);

export default TextField;
